// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brandhub-button{margin:.7142857143rem 0}.brandhub-button--edit-mode .new{background:#a0a0a0;border-radius:4px;height:2.875rem;min-width:8rem}", ""]);
// Exports
module.exports = exports;
